// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_TourItemModel from '../../model/tdg-tour-item-model';
import Tdg_TourItemDTO from '../dto/tdg-tour-item-dto';
import dtoSchema from '../schemas/tdg-tour-item-schema';

export default abstract class Tdg_TourItemModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_TourItemDTO>) {
    super();
    if (data) {
      this.orderId = data.orderId;
      this.companyId = data.companyId;
    }
  }
  /**
  * @type {int32}
  */
  orderId?: number;
  /**
  * @type {int64}
  */
  companyId?: number;

  static toModel(dto: DeepPartial<Tdg_TourItemDTO>): Tdg_TourItemModel;
  static toModel(dto: DeepPartial<Tdg_TourItemDTO> | undefined | null): Tdg_TourItemModel | undefined;
  static toModel(dto: DeepPartial<Tdg_TourItemDTO> | undefined | null): Tdg_TourItemModel | undefined {
    return dto ? new Tdg_TourItemModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_TourItemModel> | Tdg_TourItemModel): Tdg_TourItemDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      orderId: unwrapped.orderId,
      companyId: unwrapped.companyId,
    } as Tdg_TourItemDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_TourItemModel, can not map to Tdg_TourItemDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
